import OnboardingChecklist from "./OnboardingChecklistContainer";

export default OnboardingChecklist;
